import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {PageComponent} from "../../../../../core/shared/mvs-page/page.component";
import {ActivatedRoute} from "@angular/router";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {QlRequestDto} from "../../../../../core/shared/ql/data/dto/ql-request.dto";

@Component({
    selector: 'dc-config',
    templateUrl: './dc-config.component.html',
    standalone: false
})
export class DcConfigComponent extends PageComponent implements OnInit, OnChanges, OnDestroy {

    dcPageWidget: WidgetData;
    dcPageContentWidget: WidgetData;
    dcPageObjectWidget: WidgetData;
    dcPageTermWidget: WidgetData;
    dcPageTypeWidget: WidgetData;
    dcPageTypeSectionWidget: WidgetData;
    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    constructor(protected route: ActivatedRoute,
                protected coreService: MvsCoreService) {
        super(route, coreService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();

    }


    prepareDcWidgets() {
        const req = new ObjectRequestList(true, [], []);



        this.dcPageWidget = WidgetFactory.createWidgetTableEntityBasicQl('config.page.dc.page.new', 'DC Pages', 'dc.DcPage')

        this.dcPageContentWidget = WidgetFactory.createWidgetTableEntityBasicQl('config.page.dc.pagecontent.new', 'DC Page Contents', 'dc.DcPageContent')
        const request = this.dcPageContentWidget.dataProviderListRequest as QlRequestDto;

        request.queries[0].start.fields = [
            {name: "name"},
            {name: "orderPriority"},
            {name: "content"},
            // {name: "contentDisplay"},
            // {name: "contentTokens"},
        ];


        this.dcPageObjectWidget = WidgetFactory.createWidgetTableEntityBasicQl('config.page.dc.pageobject.new', 'DC Page Objects', 'dc.DcPageObject')


        this.dcPageTermWidget = WidgetFactory.createWidgetTableEntityBasicQl('config.page.dc.pageterm.new', 'DC Page Terms', 'dc.DcPageTerm')

        this.dcPageTypeWidget = WidgetFactory.createWidgetTableEntityBasicQl('config.page.dc.pagetype.new', 'DC Page Types', 'dc.DcPageType')

        this.dcPageTypeSectionWidget = WidgetFactory.createWidgetTableEntityBasicQl('config.page.dc.pagetype.section.new', 'DC Page Type Sections', 'dc.DcPageTypeSection')
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.prepareDcWidgets();
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
